var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShowImg)?_c('div',[_c('img',{staticClass:"top-content",attrs:{"src":require("./../../images/content.png"),"alt":""}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }